export type TicketStatus = 'aberta' | 'em_andamento' | 'pendente' | 'resolvida' | 'fechada' | 'reaberta';

// Mapa de transições permitidas por status atual
export const STATUS_TRANSITIONS: Record<TicketStatus, TicketStatus[]> = {
  'aberta': ['aberta', 'em_andamento', 'pendente'],
  'em_andamento': ['em_andamento', 'pendente', 'resolvida'],
  'pendente': ['pendente', 'em_andamento', 'resolvida'],
  'resolvida': ['resolvida', 'fechada', 'reaberta'],
  'reaberta': ['reaberta', 'em_andamento', 'resolvida'],
  'fechada': ['fechada'], // Estado final - sem transições
};

export const STATUS_LABELS: Record<TicketStatus, string> = {
  'aberta': 'Aberta',
  'em_andamento': 'Em Andamento',
  'pendente': 'Pendente',
  'resolvida': 'Resolvida',
  'fechada': 'Fechada',
  'reaberta': 'Reaberta',
};

export const STATUS_COLORS: Record<TicketStatus, string> = {
  'aberta': 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300',
  'em_andamento': 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300',
  'pendente': 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-300',
  'resolvida': 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
  'fechada': 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-300',
  'reaberta': 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300',
};

export function getAvailableStatusTransitions(currentStatus: TicketStatus): TicketStatus[] {
  return STATUS_TRANSITIONS[currentStatus] || [currentStatus];
}

export function isValidStatusTransition(from: TicketStatus, to: TicketStatus): boolean {
  const allowedTransitions = STATUS_TRANSITIONS[from];
  return allowedTransitions?.includes(to) || false;
}
